import { useEditCustomerMutationApi } from '@aibees/shared/features/billing-profile/api/use-edit-customer-mutation-api';
import { useReadCustomerApi } from '@aibees/shared/features/billing-profile/api/use-read-customer-api';
import { classnames } from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { memo } from 'react';
import * as Styled from './styles';
import type { DefaultCardButtonProps as Props } from './types';

export const DefaultCardButton = memo(({ className, item }: Props) => {
  const workspaceId = useWorkspace()?.id ?? '';
  const { data } = useReadCustomerApi(workspaceId);
  const { mutateAsync, isLoading } = useEditCustomerMutationApi(workspaceId);

  const isDefaultCard = data?.method === item.id;

  const handleClick = () => {
    mutateAsync({ method: item.id });
  };

  return (
    <Styled.Wrapper
      className={classnames('DefaultCardButton', className)}
      variant={isDefaultCard ? 'text' : 'outlined'}
      size="xsmall"
      loading={isLoading}
      onClick={handleClick}
      color={isDefaultCard ? 'success' : 'default'}
    >
      {isDefaultCard ? 'Default' : 'Set as Default'}
    </Styled.Wrapper>
  );
});

DefaultCardButton.displayName = 'DefaultCardButton';
